import { FsLeaderboardUser, FsLeaderboardUserBase } from "./FsLeaderboardUser";
import { FsLeaderboardSegment } from "./FsTournamentLeaderboardUser";

export type FsCombinedLeaderboardUser = FsLeaderboardUserBase & {
  segments?: FsLeaderboardSegment[] | undefined;
  tournaments: FsLeaderboardTournament[] | undefined;
};

export type FsLeaderboardTournament = {
  tournamentId: string | undefined;
  points: number | undefined;
};

export const isFsCombinedLeaderboardUser = (
  user: FsLeaderboardUser
): user is FsCombinedLeaderboardUser => {
  return (user as FsCombinedLeaderboardUser).tournaments !== undefined;
};
